import React from "react";

import "./path-array.css";
import { Button, ConfigProvider } from "antd";
import { text } from "stream/consumers";
import { HomeOutlined } from "@ant-design/icons";

interface PathArrayComponentProps {
  theme: string;
  pathElements: string[];
  onPathArrayClick: (pathElementsArray: string[], index: number) => void;
  numberOfDisabled: number;
}

export const PathArrayComponent = ({
  theme,
  pathElements,
  onPathArrayClick,
  numberOfDisabled,
}: PathArrayComponentProps) => {
  const handlePathArrayClick = (pathElementsArray: string[], index: number) => {
    onPathArrayClick(pathElementsArray, index);
  };

  const textColor = theme === "light" ? "#000000" : "#ffffff";

  return (
    <div style={{ color: textColor }} className="pathColumnText">
      Folder :{" "}
      <Button
        type="text"
        className="pathColumnButton"
        onClick={() => handlePathArrayClick(pathElements, 0)}
        disabled={0 < numberOfDisabled}
      >
        <HomeOutlined />
      </Button>
      {pathElements.map((pathElement, index) => (
        <React.Fragment key={index}>
          {index !== 0 && (
            <>
              <span style={{ color: textColor }}> / </span>
              <Button
                type="text"
                className="pathColumnButton"
                onClick={() => handlePathArrayClick(pathElements, index)}
                disabled={index < numberOfDisabled}
              >
                {pathElement}
              </Button>
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
